var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroller",on:{"click":function($event){return _vm.scrollToNextPosition()}}},[_c('i',{staticClass:"fas fa-angle-double-down"})])}
var staticRenderFns = []

export { render, staticRenderFns }